<div class="card dialog-box">
  <div class="card-header">
    Source
    <span (click)="onDismis(false)" class="float-end">
      <i class="fa-solid fa-xmark"></i>
    </span>
  </div>
  <!-- @if (["updateClient", "chat"].includes(this.showFrom)) { -->
  <!-- <div class="btn-group" role="group" aria-label="photo-video">
    <div
      class="btn d-flex align-items-center justify-content-center gap-3"
      role="button"
      [ngClass]="
        fileType == 'image' ? 'btn-secondary' : 'btn-outline-secondary'
      "
      (click)="fileType = 'image'"
    >
      <i class="fa-solid fa-camera fs-5"></i>
      Photo
    </div>
    <div
      class="btn d-flex align-items-center justify-content-center gap-3"
      role="button"
      [ngClass]="
        fileType == 'video' ? 'btn-secondary' : 'btn-outline-secondary'
      "
      (click)="fileType = 'video'"
    >
      <i class="fa-solid fa-video fs-5"></i>
      Video
    </div>
  </div> -->
  <!-- } -->
  <div class="d-flex flex-column gap-3 my-3">
    <button class="btn btn-primary w-100 btn-xl" (click)="onDismis('device')">
      <div class="d-flex align-items-center justify-content-center gap-3">
        <span>
          <i class="fa-solid fa-image fa-2x"></i>
        </span>

        <span>Device</span>
      </div>
    </button>
    <button class="btn btn-primary w-100 btn-xl" (click)="onDismis('live')">
      <div class="d-flex align-items-center justify-content-center gap-3">
        @if (fileType == "image") {
          <span>
            <i class="fa fa-camera fa-2x"></i>
          </span>
        } @else {
          <span>
            <i class="fa fa-video fa-2x"></i>
          </span>
        }

        <span>Camera</span>
      </div>
    </button>
    @if (
      !offlineMode &&
      fileType === "image" &&
      !["credentialPhoto"].includes(showFrom)
    ) {
      <button
        class="btn btn-primary w-100 btn-xl"
        (click)="onDismis('live', true)"
      >
        <div class="d-flex align-items-center justify-content-center gap-3">
          <span>
            <i class="fa fa-camera fa-2x"></i>
          </span>
          <span>Camera (with timestamp)</span>
        </div>
      </button>
    }
  </div>

  <div class="col">
    <button class="btn btn-dark btn-lg w-100" (click)="onDismis(false)">
      Cancel
    </button>
  </div>
</div>
